import React, {useEffect, useState} from 'react';
import axios from "axios";
const apiRoot = process.env.MIX_API_ROOT;
import SearchResults from "./SearchResults";
import CollectionSelect from "./CollectionSelect";
import TypeSelect from "./TypeSelect";

import {sample} from "lodash";

export default function Search(props) {
    const [isLoading, setLoading] = useState(false);
    const [types,setTypes] = useState([]);
    const [collections,setCollections] = useState([]);

    const hints = {
        'taxon': 'Allenypterus montanus',
        'locality': 'Burgess Shale',
        'common name':'Rhinoceros',
        'catalog number':'9992',
        'age':'Triassic',
        'state':'Montana',
        'country':'Japan',
        'formation':'Cabbage Patch',
        'type':'Holotype'
    };

    const hintType = sample(Object.keys(hints));

    useEffect(()=>{
        axios.get(apiRoot + '/types').then((response) => {
            setTypes(response.data)
        })
        axios.get(apiRoot + '/collections').then((response) => {
            setCollections(response.data)
        })
    },[])

    const setSearchTerm = (term) => {
        const newState = Object.assign({},props.state,{term:term});
        props.setState(newState);
    }

    const setSearchResults = (results) => {
        const newState = Object.assign({},props.state,{results:results});
        props.setState(newState);
    }

    const setHasType = (hasType) => {
        const newState = Object.assign({},props.state,{hasType:hasType});
        props.setState(newState);
    }

    const setHasImages = (hasImages) => {
        const newState = Object.assign({},props.state,{hasImages:hasImages});
        props.setState(newState);
    }

    const setSearchType = (searchType) => {
        const newState = Object.assign({},props.state,{searchType:searchType});
        props.setState(newState);
    }


    const setSelectedCollection = (collection) => {
        const newState = Object.assign({},props.state,{selectedCollection: collection});
        props.setState(newState);
    }

    const setSelectedType = (type) => {
        const newState = Object.assign({},props.state,{selectedType: type});
        props.setState(newState);
    }

    const handleChange = ( event ) => {
        setSearchTerm(event.target.value)
    }

    const runSearch = (event) => {
        event.preventDefault()
        loadSearchResultPage(apiRoot+'/search', {
            params: {
                'searchtext': props.state.term,
                'searchtype': props.state.searchType,
                'hastype': props.state.hasType ? 1 : 0,
                'images': props.state.hasImages ? 1 : 0,
                'collection': props.state.selectedCollection,
                'type': props.state.selectedType
            }
        })
    }

    const loadSearchResultPage = (url, params) => {
        setLoading(true);
        axios.get(url, params).then((response) => {
            // data comes back structured a bit different without a paginator
            if (!url.match(/pageSize=all/))
                setSearchResults(response.data.results)
            else
                setSearchResults({data: response.data.results})
            setLoading(false);
        })
    }

    const toggleHasType = () => {
        setHasType(!props.state.hasType)
    }

    const toggleHasImages = () => {
        setHasImages(!props.state.hasImages)
    }

    let results = isLoading
        ? (<div className="alert alert-light">Loading . . . </div>)
        : (<SearchResults results={props.state.results} loadSearchResultPage={loadSearchResultPage} />)


    return (
        <div>
            <form>
                <div className={'form-group mb-3'}>
                <div className={'input-group'}>
                    <input
                        id={'search-term'}
                        type={"text"}
                        value={props.state.term}
                        className={'form-control'}
                        onChange={handleChange}
                        placeholder={'Search'}
                        aria-describedby={'Search'}
                    />
                    <div className={'input-group-append'}>
                        <button
                            type="submit"
                            className="btn btn-primary mb-2"
                            onClick={runSearch}
                        >
                            Search
                        </button>
                    </div>
                </div>
                    { props.state.term === '' ? <small className="form-text text-muted">
                        Try searching for the {hintType} "{hints[hintType]}"
                    </small> : null }

                </div>
                <fieldset className={'form-group'}>
                    <legend>Search Settings</legend>
                    <div className={'form-check form-check-inline'}>
                        <input
                            type="radio"
                            name="searchtype"
                            value="any"
                            checked={props.state.searchType === "any"}
                            onChange={(e) => setSearchType('any') }
                            className={'form-check-input'}
                            id={'anySearchTypeRadio'}
                        />
                        <label className={'form-check-label'} htmlFor={'anySearchTypeRadio'}>
                             Any search terms
                        </label>
                    </div>
                    <div className={'form-check form-check-inline'}>
                        <input
                            type="radio"
                            name="searchtype"
                            value="all"
                            checked={props.state.searchType === "all"}
                            onChange={() => setSearchType('all') }
                            id={'allSearchTypeRadio'}
                            className={'form-check-input'}
                        />
                        <label className={'form-check-label'} htmlFor={'allSearchTypeRadio'} >
                             All search terms
                        </label>
                    </div>
                    <div className={'form-check form-check-inline'}>
                        <input
                            type="checkbox"
                            id="hastype"
                            name="hastype"
                            value="1"
                            checked={props.state.hasType}
                            onChange={toggleHasType}
                            className={'form-check-input'}
                        />
                        <label htmlFor="hastype" className={'form-check-label'}>
                            Has Type
                        </label>
                    </div>

                    <div className={'form-check form-check-inline'}>
                        <input
                            type="checkbox"
                            id="images"
                            name="images"
                            value="1"
                            checked={props.state.hasImages}
                            onChange={toggleHasImages}
                            className={'form-check-input'}
                        />
                        <label htmlFor="images" className={'form-check-label'}>
                            Has Images
                        </label>
                    </div>

                    <div className="row">
                        <CollectionSelect collections={collections} selected={props.state.selectedCollection} onChange={setSelectedCollection} />
                        <TypeSelect types={types} selected={props.state.selectedType} onChange={setSelectedType} />
                    </div>

                </fieldset>
            </form>
            {results}
        </div>
    )
}
